import { AfterViewInit, Directive, ElementRef, Injector, Input } from '@angular/core';
import { DateTimeService } from './date-time.service';

@Directive({ selector: '[dateRangePickerInitialValue]', })
export class DateRangePickerInitialValueSetterDirective implements AfterViewInit {
    hostElement: ElementRef;
    @Input() ngModel;

    constructor(injector: Injector, private readonly _element: ElementRef, private readonly _dateTimeService: DateTimeService) {
        this.hostElement = _element;
    }

    ngAfterViewInit(): void {
        if (this.ngModel && this.ngModel[0] && this.ngModel[1]) {
            setTimeout(() => {
                let value =
                    this._dateTimeService.formatDate(this.ngModel[0], 'F') +
                    ' - ' +
                    this._dateTimeService.formatDate(this.ngModel[1], 'F');
                (this.hostElement.nativeElement as any).value = value;
            });
        }
    }
}
